import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../../../components/activity/AppContext";
import { useForm } from "../../../../../components/forms/Form";
import PopUp from "../../../../../components/layouts/PopUp";
import { validateValue, validateValues } from "../../../../businessFunctions/validations";
import { SchedulerActions } from "../../scheduler.action";
import { useScheduler } from "../../schedulerContext";
import styles from "./FinalStep.module.css"
import editIcon from "../../../../../images/editicon.svg";
import { getAuth } from "../../../../../auth/user";

export const FinalStep = ({ show, handleClose, loadSchedulerList }) => {
    const app = useAppContext();
    let style = { marginTop: "8px" };
    let style1 = { cursor: "pointer" };

    const [data, setData] = useState("")
    const [popupTitle, setPopupTitle] = useState("")
    const [popupTestId, setPopupTestId] = useState("")

    const { edit, setTimeBasedEdit, setTimeBased, setBospopup, setParameter,
        setTrigger, setBospopupEdit, setTriggerEdit, setParameterEdit, timeBasedSchedulerForm,setParams,parameters,
        params, freq, paramObject, isTimeBased, setCreateScheduler, createScheduler, id, prevName, isEnabled, save, setSave , setEdit } = useScheduler();

    const onWatch = (errors, data) => {
        validateValue(errors, data.name, data.value);
    }

    const onSubmit = async (values, errors) => {

        if (!validateValues(values, errors))
            return false;

        // let payload = { ...values };
        // const project = ProjectsActions(app())
        // const [error, data] = await project.createNewProject(payload);

        // if (error || !data.status?.code) {
        //     setApiError(error || data.status?.message);
        //     return false;
        // } else {
        //     handleClose();
        //     navigate(`/project/${values.name}`);
        //     return true;
        // }
    }

    const { Form, Label, Input } = useForm(data, onSubmit, onWatch);

    useEffect(() => {
        if (edit) {
            setPopupTestId("edit-schedule")
            setPopupTitle("Edit schedule")
        } else {
            setPopupTestId("confirm-schedule")
            setPopupTitle("Final step,confirm your schedule")
        }

    })

    const handleEdit1 = () => {
        handleClose()
        setTimeBased(true)
        setTimeBasedEdit(true)
        setSave(true)
    }

    const handleEdit2 = () => {
        handleClose()
        setBospopup(true)
        setBospopupEdit(true)
        setSave(true)
    }

    const handleEdit3 = () => {
        handleClose()
        setParameter(true)
        setParameterEdit(true)
        setSave(true)
    }

    const handleEdit4 = () => {
        handleClose()
        setTrigger(true)
        setTriggerEdit(true)
        setSave(true)
    }

    // Deeply escape newline characters in all string values so that \n is preserved literally
    const escapeNewlinesDeep = (value) => {
        if (typeof value === "string") {
            // 1) Convert real newlines (LF/CRLF) to literal \n
            // 2) If there are any number of backslashes before 'n' (e.g., \\n, \\\n),
            //    normalize them to exactly one: \n
            let s = value.replace(/\r?\n/g, "\\n")
            s = s.replace(/\\+n/g, "\\n")
            return s
        }
        if (Array.isArray(value)) {
            return value.map(escapeNewlinesDeep)
        }
        if (value && typeof value === "object") {
            const out = {}
            Object.keys(value).forEach((k) => {
                out[k] = escapeNewlinesDeep(value[k])
            })
            return out
        }
        return value
    }

    const CreateScheduler = async (payload) => {
        const actions = SchedulerActions(app());
        const [error, data] = await actions.CreateSchedulerBasedonTime(payload);
        if (!error) {
            console.log(data)
        }
    }

    const UpdateSchedulers = async (payload, id) => {
        const actions = SchedulerActions(app());
        const [error, data] = await actions.UpdateScheduler(payload, id);
        if (!error) {
            console.log(data)
        }
    }

    const handleCreate = (el) => {
        try{
            const payload = {
                    bosname: params.serviceId,
                    description: timeBasedSchedulerForm.description,
                    eventId: null,
                    freq: freq.map(obj => {
                    const { id, ...rest } = obj;
                    return rest; 
                    }),
                    isEnabled: el === "enabled" ? 1 : 0,
                    isTimeBased: isTimeBased,
                    name: timeBasedSchedulerForm.name,
                    // Ensure newlines in parameter string values are sent as literal \n
                    parameters: JSON.stringify(escapeNewlinesDeep(parameters)),
                    projectComponentId: params.projectComponentId,
                    runAsUser: params.runAsUser,
                    serviceName: params.projectName+"."+params.bosName+"."+params.runAsUser,
                    serviceType: timeBasedSchedulerForm.serviceType
                }

                CreateScheduler(payload)
                handleClose()
                setTimeout(() => setCreateScheduler(!createScheduler), 1000)
                setParams({
                    projectName: "",
                    bosName: "",
                    serviceId: "",
                    projectComponentId: "",
                })
                setSave(false)
                setEdit(false)
        }
        catch(err){
            console.log(err)
        }
  
   
               

    }

    const handleUpdate = (el) => {
        try{
            let bosParameters = JSON.stringify(escapeNewlinesDeep(parameters))
            const payload = {
                bosname: params.serviceId,
                description: timeBasedSchedulerForm.description,
                eventId: null,
                freq: freq.map(obj => {
                const { id, ...rest } = obj;
                return rest; 
                }),
                id: id,
                isEnabled: el === "enabled" ? 1 : 0,
                isTimeBased: true,
                name: timeBasedSchedulerForm.name,
                parameters: bosParameters,
                projectComponentId: params.projectComponentId,
                runAsUser: params.runAsUser,
                serviceName: params.projectName+"."+params.bosName+"."+params.runAsUser,
                serviceType: timeBasedSchedulerForm.serviceType
            }

            UpdateSchedulers(payload, prevName)
            handleClose()
            setTimeout(() => setCreateScheduler(!createScheduler), 1000)
            setParams({
                projectName: "",
                bosName: "",
                serviceId: "",
                projectComponentId: "",
                runAsUser: getAuth().auth.loginName
            })
            setSave(false)
            setEdit(false)
        }
        catch(err){
            console.log(err)
        }
        // Escape newlines in parameters before stringifying
     
        

    }

    const constructParamters = () =>{
        try{
            const newParamter = {
                ...parameters,
                bosName:params.bosName,
                projectName:params.projectName,
                uuid:params.serviceId,
    
            }

            return JSON.stringify(newParamter,null,2)
        }
        catch(err){
            console.log(err);
        }
      

        
    }

    const buildSentence = (el) => {
    switch (el.drp) {
        case "days":
        return `Repeat every ${el.times} day${el.times > 1 ? "s" : ""} at ${el.hr || 0} hrs ${el.min || 0} mins`;

        case "weeks":
        return `Repeat every ${el.times} week${el.times > 1 ? "s" : ""} on ${el.week} at ${el.hr || 0} hrs ${el.min || 0} mins`;

        case "months":
        return `Repeat every ${el.times} month${el.times > 1 ? "s" : ""} on the ${el.day} at ${el.hr || 0} hrs ${el.min || 0} mins`;

        case "hours":
        case "minutes":
        return `Repeat every ${el.times} ${el.drp}`;

        default:
        return "";
    }
    };


   


    return <>
        <PopUp popUp={show} setPopUp={handleClose} testId={popupTestId} titleClassName={styles.finalHeader} title={popupTitle} >
            {/* <h1 className={styles.finalHeader}>
                {edit ? "Edit schedule" : "Final step,confirm your schedule"}
            </h1> */}
            <Form>
                <div className={styles.formArea}>
                    <div className={styles.column}>
                        <div className={styles.finalComp}>
                            <Label text={"Name"} style={style} className={styles.label} />
                            <Label text={timeBasedSchedulerForm.name} style={style} className={styles.label2} />
                            <img src={editIcon} data-clickable-testid={"Name"} style={style1} onClick={handleEdit1} />
                        </div>
                        <div className={styles.finalComp}>
                            <Label text={"Description"} style={style} className={styles.label} />
                            <Label text={timeBasedSchedulerForm.description} style={style} className={styles.label2} />
                            <img src={editIcon} data-clickable-testid={"Description"} style={style1} onClick={handleEdit1} />
                        </div>
                        <div className={styles.finalComp}>
                            <Label text={"Type"} style={style} className={styles.label} />
                            <Label text={timeBasedSchedulerForm.serviceType} style={style} className={styles.label2} />
                            <img src={editIcon} data-clickable-testid={"Type"} style={style1} onClick={handleEdit1} />
                        </div>
                        <div className={styles.finalComp}>
                            <Label text={"BOS"} style={style} className={styles.label} />
                            <Label text={params.bosName} style={style} className={styles.label2} />
                            <img src={editIcon} data-clickable-testid={"BOS"} style={style1} onClick={handleEdit2} />
                        </div>
                        {/* JSON.stringify(parameters, null, 2) */}
                        <div className={styles.finalComp} >
                            <Label text={"Parameters"} style={style} className={styles.label} />
                            <Label text={constructParamters()} style={{...style,lineHeight:"20px",height:150,overflow:"hidden",textOverflow:"ellipsis"}} className={styles.param} />
                            <img src={editIcon} data-clickable-testid={"Parameters"} style={style1} onClick={handleEdit3} />
                        </div>
                        <div className={styles.finalComp} style={style}>
                            <Label text={"Triggers"} style={style} className={styles.label} />
                            <div style={{ width: "14rem" }}>
                          <div style={{ width: "14rem" }}>
                                    {freq.length > 0 &&
                                        freq.map((el) => (
                                        <div key={el.id}>
                                            <Label text={buildSentence(el)} />
                                        </div>
                                        ))}
                                    </div>

                            </div>

                            <img src={editIcon} data-clikable-testid={"Triggers"} style={style1} onClick={handleEdit4} />

                        </div>
                    </div>
                </div>
                <div className={styles.finalButton}>
                    {
                        !edit ? <>
                            <Input
                                type="button"
                                value={"Create without enabling"}
                                className="secondary"
                                onClick={() => handleCreate("disabled")}
                            />
                            <Input type="submit" className="primary" value={"Create and enable schedule"} onClick={() => handleCreate("enabled")} /></> :
                            <>
                                <Input
                                    type="button"
                                    value={"Save without enabling"}
                                    className="secondary"
                                    onClick={() => handleUpdate("disabled")}
                                />
                                <Input type="submit" className="primary" value={"Save and enable schedule"} onClick={() => handleUpdate("enabled")} /></>
                    }

                </div>


            </Form>
        </PopUp>
    </>
}